import React, { useEffect, useState } from "react";
import "./Reminder.css";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { LiaEditSolid } from "react-icons/lia";
import {
  Modal,
  Box,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Typography,
} from "@mui/material";

const Reminder = () => {
  const navigate = useNavigate(); 
  const currentDate = new Date().toISOString().split("T")[0];
  const currentTime = new Date().toTimeString().slice(0, 5);
  const [loading, setLoading] = useState(false); 
  const [reminders, setReminders] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({
    date: currentDate,
    category: "",
    description: "",
    times: currentTime
  });
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState(null);
  const [formDataEdit, setFormDataEdit] = useState({
    date: "",
    category: "",
    description: "",
    times: ""
  });
  const handleCloseModal = () => {
    setOpenModal(false);
    setFormDataEdit({
      date: "",
      category: "",
      description: "",
      times: ""
    })
    setEdit(null);
  };
  const handleOpenModal = (expense) => {
    console.log("expense",expense)
    setEdit(expense);
    setFormDataEdit({
        description: expense?.description,
        category: expense?.category,
        date:  expense?.date ? expense?.date.split("T")[0] : "",
        times: expense?.time,
      });
      setOpenModal(true);
    };
    console.log("expense",formDataEdit)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormDataEdit((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      navigate("/welcome");
    } else {
      fetchReminders(token, 1);
    }
  }, [navigate]);



  // const reminder = Array.from({ length: 25 }, (_, index) => ({
  //   id: index + 1,
  //   image: "./Clock.png",
  //   title: "Shopping",
  //   date: "2024-11-17",
  //   description: "Groceries and essentials",
  // }));

  const clearForm = () => {
    setFormData({
      date: currentDate,
      category: "",
      description: "",
      times: currentTime,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      toast.info("Please log in again.");
      return;
    }
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const data = {
      time: formData.times,
      date: formData.date,
      category: formData.category,
      description: formData.description || "",
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/reminder`,
        data,
        config
      );
      toast.success(response?.data?.message || "Reminder added successfully!", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
        transition: Bounce,
      });
      setReminders([]);
    setPage(1);
    await fetchReminders(token, 1); 
      clearForm();
    } catch (error) {
      console.error("Error adding reminder:", error);
      toast.error(error?.response?.data?.message || "Failed to add reminder.", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
        transition: Bounce,
      });
    }  finally {
      setLoading(false); 
    }
  };

  const fetchReminders = async (token, currentPage) => {
    setReminders([]);
    try {
      const response = await axios.get(
        `https://expense.dpstrust.in/api/reminder/all?page=${currentPage}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        const newReminders = response.data.data.reminders;

        const uniqueReminders = Array.from(
          new Map(
            [...reminders, ...newReminders].map((item) => [item._id, item])
          ).values()
        );

        setReminders(uniqueReminders);
        if (newReminders.length < 10) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching reminders:", error);
      setHasMore(false);
    }
  };


  const loadMoreReminders = () => {
    const token = localStorage.getItem("tokenexpense");
    const nextPage = page + 1;
    setPage(nextPage);
    fetchReminders(token, nextPage);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: 3,
    borderRadius: 2,
    boxShadow: 24,
    width: "90%"
  };
  const buttonContainerStyle = {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  };

  const buttonStyle = {
    flex: 1,
    maxWidth: "150px",
  };

  const handleSaveExpense = async () => {
    if (!formDataEdit.description || !formDataEdit.category || !formDataEdit.times || !formDataEdit.date) {
      toast.info("Please fill all the required fields.", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
        transition: Bounce,
      });
      return;
    }
    const token = localStorage.getItem("tokenexpense");
    try {
      const response = await axios.put(
        `https://expense.dpstrust.in/api/reminder/${edit._id}`,
        formDataEdit,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchReminders(token, page);
      handleCloseModal();
    } catch (error) {
      console.error("Error saving reminder:", error);
    }
  };


  return (
    <>
    <ToastContainer/>
      <Header heading="Reminder" />
      <form onSubmit={handleSubmit} className="reminder-form">

      <div className="reminder-container">
     
<div style={{display:"flex", flexDirection:"column", boxSizing:"border-box" }}>
<input className="inputfieldreminder"
type="date"
name="date"
value={formData.date}
onChange={handleChange}
defaultValue={currentDate} 
placeholder="Select Date" required/>

<select className="inputfieldreminder" name="category"
                value={formData.category} required
                onChange={handleChange}>
            <option value="">Select Category</option>
            <option value="work">Work</option>
            <option value="personal">Personal</option>
            <option value="health">Health</option>
          </select>

<input className="inputfieldreminder"
 type="text" required
 placeholder="Description" name="description"
 value={formData.description}
 onChange={handleChange}
 />

<input className="inputfieldreminder"
 type="time" required
 name="times"
value={formData.times}
onChange={handleChange}
            defaultValue={currentTime} 
            placeholder="Set Reminder Time"/>
</div>
<div className="action-buttons-reminder">
              <button
                className="action-button-reminder edit-button-reminder"
                onClick={clearForm}     type="button" 
              >
                Reset
              </button>
              <button
                className="action-button-reminder edit-button-reminder"
                type="submit"
                disabled={loading} 
                >
                  {loading ? "Saving..." : "Save"} 
                </button>
            </div>
            </div>
            </form>

      
      <InfiniteScroll style={{paddingBottom:"90px"}}
        dataLength={reminders.length}
        next={loadMoreReminders}
        hasMore={hasMore}
        loader={<h4 style={{ textAlign: "center" }}>Loading more reminders...</h4>}
        endMessage={
          reminders.length > 0 ? (
            <p style={{ textAlign: "center" }}>No more reminders</p>
          ) : (
            <p style={{ textAlign: "center", color: "red" }}>
              No reminders available
            </p>
          )
        }
      >
       <ul className="reminder-list">
        {reminders?.map((reminder) => (
          <li key={reminder?.id} className="reminder-item">
            <img
              src='./Clock.png'
              className="reminder-image"
            />
            <div className="reminder-details">
              <div className="reminder-title">{reminder?.category} </div>
              <div className="reminder-date">{new Date(reminder?.date).toLocaleDateString()}, {reminder?.time}</div>
              <div className="reminder-description">{reminder?.description}</div>
            </div>
            <LiaEditSolid className="edit-icon" onClick={()=>handleOpenModal(reminder)}/>
          </li>
        ))}
      </ul>
      </InfiniteScroll>
      <Modal open={openModal} onClose={handleCloseModal}>
      <Box sx={modalStyle}>
        <Typography variant="h6" gutterBottom>
          Edit Expense
        </Typography>
        <TextField
          label="Description"
          variant="outlined"
          fullWidth
          name="description"
          value={formDataEdit.description}
          onChange={handleFormChange}
          margin="normal"
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select
            label="Category"
            name="category"
            value={formDataEdit.category}
            onChange={handleFormChange}
          >
              <MenuItem value="work">Work</MenuItem>
              <MenuItem value="personal">Personal</MenuItem>
              <MenuItem value="health">Health</MenuItem>

          </Select>
        </FormControl>
        <TextField
          label="Date"
          variant="outlined"
          fullWidth
          type="date"
          name="date"
          value={formDataEdit.date}
          onChange={handleFormChange}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="Date"
          variant="outlined"
          fullWidth
          type="time"
          name="time"
          value={formDataEdit.times}
          onChange={handleFormChange}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        />
        
        <div style={buttonContainerStyle}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveExpense}
            style={buttonStyle}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleCloseModal}
            style={buttonStyle}
          >
            Cancel
          </Button>
        </div>
      </Box>
    </Modal>
    </>
  );
};

export default Reminder;
